import { GuardsService } from "./../services/guards/guards.service";
import DashboardLayout from "../layouts/dashboard/dashboard.layout";
import SettingsLayout from "../layouts/settings/settings.layout";
import LoginPage from "../pages/login/login.page";
import UsersPage from "../pages/users/users.page";
import DashboardPage from "../pages/dashboard/dashboard.page";
import ProfilePage from "../pages/settings/profile/profile.page";
import RolesManagementPage from "../pages/settings/roles-managment/roles-management.page";
import SignUpPage from "../pages/sign-up/sign-up.page";
import FallbackPage from "../pages/fallback/fallback";
import ForgotPasswordPage from "../pages/forgot-password/forgot-password.page";
import ResetPasswordPage from "../pages/reset-password/reset-password.page";
import Workspace from "../pages/settings/workspace/workspace.page";
import WorkflowManagementPage from "../pages/settings/workflow-management/workflow-management.page";
import TranslationManagementPage from "../pages/settings/translation-management/translation-management.page";
import BranchManagementPage from "../pages/settings/branch-management/branch-management.page";
import LogfilePage from "../pages/settings/logfile/logfile.page";
// import CreateWorkSpacePage from "../pages/workspaces/create-workspace/create-workspace.page";
import WorkspacesPage from "../pages/workspaces/list-workspaces/list-workspaces.page";
import CasePage from "../pages/case/case-details/case.page";
// import CreateCasePage from "../pages/case/create-case/create-case.page";
import PrintCasePage from "../pages/case/case-print/case-print.page";
// import ComingSoonPage from "../pages/comming-soon/coming-soon.page";
import AIDemandPage from "../pages/cases/ai-demand/ai-demand.page";
import AITrackingPage from "../pages/cases/ai-tracking/ai-tracking.page";
import AIAssessmentPage from "../pages/cases/ai-assessment/ai-assessment.page";
import LandscapePage from "../pages/landscape/landscape.page";
import TasksPage from "../pages/tasks/tasks.page";
import ThirdPartyPage from "../pages/thirdy-party-login/thirdy-party-login.page";
import DataExchangePage from "../pages/settings/data-exchange/data-exchange.page";
import CaseAssistantPage from "../pages/case/case-assistant/case-assistant.page";
import ProductsPage from "../pages/products/products.page";
import AIUseCasesPage from "../pages/cases/ai-use-cases/ai-use-cases.page";
import AIDevelopmentPage from "../pages/cases/ai-development/ai-development.page";
import RiskLevelManagementPage from "../pages/settings/risk-level-management/risk-level-management.page";
import { QuestionsBuilderPage } from "../pages/settings/questions-builder/questions-builder.page";
import CoursesPage from "../pages/education/courses.page";
import CourseDetailsPage from "../pages/education/course-details.page";
import VideoDetailsPage from "../pages/education/video-details.page";
import ProductDetailsPage from "../pages/products/product-details.page";
import WorkSpaceWizardPage from "../pages/workspaces/workspace-wizard/workspace-wizard.component";
import ReusableComponentsPage from "../pages/reusable-components/reusable-components.page";
import CheckpointDetailsPage from "../pages/education/checkpoint-details.page";
import CheckpointExamPage from "../pages/education/checkpoint-exam.page";

const guardsService: GuardsService = new GuardsService();

const routes = [
  {
    path: "/login",
    title: "Login",
    component: LoginPage,
    canActivate: [guardsService.isNotAuthorized],
  },
  {
    path: "/community-login",
    title: "Community Login",
    component: ThirdPartyPage,
  },
  {
    path: "/signup/:id/:tenantId",
    title: "signup",
    component: SignUpPage,
  },
  {
    path: "/forgot-password",
    title: "forgot password",
    component: ForgotPasswordPage,
    canActivate: [guardsService.isNotAuthorized],
  },
  {
    path: "/reset-password/:id",
    title: "signup",
    component: ResetPasswordPage,
    canActivate: [guardsService.isNotAuthorized],
  },
  {
    path: "/workspaces",
    title: "workspaces",
    component: WorkspacesPage,
    canActivate: [guardsService.isAuthorized],
  },
  // {
  //   path: "/on-boarding",
  //   title: "Onboarding",
  //   component: CreateWorkSpacePage,
  //   canActivate: [guardsService.isSuperAdmin],
  // },
  {
    path: "/workspace-wizard",
    title: "Workspace Wizard",
    component: WorkSpaceWizardPage,
    canActivate: [guardsService.isSuperAdmin],
  },
  {
    path: "/",
    canActivate: [guardsService.isAuthorized],
    component: DashboardLayout,
    routes: [
      {
        path: "/reusable-components",
        title: "Reusable UI Components",
        component: ReusableComponentsPage,
        canActivate: [guardsService.isSuperAdmin],
      },
      {
        path: "/dashboard",
        title: "dashboard",
        component: DashboardPage,
      },
      {
        path: "/landscape",
        title: "landscape",
        component: LandscapePage,
      },
      {
        path: "/ai-products",
        title: "products",
        component: ProductsPage,
        canActivate: [guardsService.isSuperUser],
      },
      {
        path: "/product/:id",
        title: "Product Details",
        component: ProductDetailsPage,
        canActivate: [guardsService.isSuperUser],
      },
      {
        path: "/ai-use-cases",
        title: "AI-UseCases",
        component: AIUseCasesPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/ai-software-development",
        title: "AI-Software Development",
        component: AIDevelopmentPage,
        canActivate: [guardsService.isCaseAdmin],
      },

      {
        path: "/ai-demand",
        title: "AI Demand Manager",
        component: AIDemandPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/ai-compliance-tracking",
        title: "AI Compliance Tracking",
        component: AITrackingPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/ai-risk-assessment",
        title: "AI Risk Assessment",
        component: AIAssessmentPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/education",
        title: "Education",
        routes: [
          {
            path: "/education/courses",
            title: "Education",
            component: CoursesPage,
            canActivate: [guardsService.isAuthorized],
          },
          {
            path: "/education/course/:id",
            title: "Course Details",
            component: CourseDetailsPage,
            canActivate: [guardsService.isAuthorized],
          },
          {
            path: "/education/lesson/:id",
            title: "Video Details",
            component: VideoDetailsPage,
            canActivate: [guardsService.isAuthorized],
          },
          {
            path: "/education/checkpoint/:id",
            title: "Checkpoint Details",
            component: CheckpointDetailsPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/education/exam/:id",
            title: "Exam",
            component: CheckpointExamPage,
            canActivate: [guardsService.isAuthorized],
          },
          {
            path: "*",
            redirect: "/education/courses",
          },
        ],
      },
      {
        path: "/ai",
        title: "Create Case Assistant",
        component: CaseAssistantPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/case/print",
        title: "Print Case",
        component: PrintCasePage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/case/:id",
        title: "Case Details",
        component: CasePage,
        canActivate: [guardsService.isCaseAdmin],
      },

      {
        path: "/user-management",
        title: "Users",
        component: UsersPage,
        canActivate: [guardsService.isSuperUser],
      },
      {
        path: "/ai-tasks",
        title: "AI-Tasks",
        component: TasksPage,
        canActivate: [guardsService.isCaseAdmin],
      },
      {
        path: "/settings",
        component: SettingsLayout,
        routes: [
          {
            path: "/settings/profile",
            title: "User Management",
            component: ProfilePage,
          },
          {
            path: "/settings/data-exchange",
            title: "Data Exchange",
            component: DataExchangePage,
          },
          {
            path: "/settings/workspace-management",
            title: "Workspace Management",
            component: Workspace,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/role-management",
            title: "Roles Management",
            component: RolesManagementPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/workflow-management",
            title: "Workflow Management",
            component: WorkflowManagementPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/questions-builder",
            title: "Questions Builder",
            component: QuestionsBuilderPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/database-value-management",
            title: "Translation Management",
            component: TranslationManagementPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/branch-management",
            title: "Branch Management",
            component: BranchManagementPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/activity-log",
            title: "Logfile",
            component: LogfilePage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings/risk-level-management",
            title: "Risk Level Management",
            component: RiskLevelManagementPage,
            canActivate: [guardsService.isSuperUser],
          },
          {
            path: "/settings",
            redirect: "/settings/profile",
          },
          {
            path: "*",
            component: FallbackPage,
          },
        ],
      },
      {
        path: "/",
        redirect: "/dashboard",
      },
      {
        path: "/temp",
      },
      {
        path: "/",
        redirect: "/dashboard",
      },
      {
        path: "/home",
        redirect: "/dashboard",
      },
      {
        path: "*",
        // redirect: "/dashboard",
        component: FallbackPage,
      },
    ],
  },
  {
    path: "*",
    redirect: "/dashboard",
  },
];

export default routes;
